<template>
  <div class='h100-80 h-scroll'>
    <ejs-grid ref="dataOfPmNoRealTaskList" :dataSource="mrTaskData" :rowSelected='rowSelectedOfMr' :rowDeselected='rowDeselectedOfMr'>
      <e-columns>
        <e-column field='neName' :headerText='$t("MR.neName")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neVersion' :headerText='$t("MR.neVersion")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neIp' :headerText='$t("MR.neIp")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='nePort' :headerText='$t("MR.nePort")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='enableStatus' :headerText='$t("MR.enableStatus")' :disableHtmlEncode='false' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip' :formatter="enableStatusFormatter"></e-column>
        <e-column field='measureType' :headerText='$t("MR.measureType")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='omcName' :headerText='$t("MR.omcName")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='samplePeriod' :headerText='$t("MR.samplePeriod")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='uploadPeriod' :headerText='$t("MR.uploadPeriod")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='sampleBeginTime' :headerText='$t("MR.sampleBeginTime")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='sampleEndTime' :headerText='$t("MR.sampleEndTime")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='prbNum' :headerText='$t("MR.prbNum")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='subFrameNum' :headerText='$t("MR.subFrameNum")' textAlign='Center' width='7%' clipMode='EllipsisWithTooltip'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref="pagerForPmNoRealTaskList" :currentPage='page.currentPage' :pageCount='page.pageCount' :pageSize='page.pageSize' :totalRecordsCount='page.totalRecordsCount'></ejs-pager>
  </div>
</template>

<script>
    export default {
        name: "MrTaskManagementList",
        data() {
          return {
            mrTaskData: [],
            page: {
              currentPage: 1,
              pageSize: 25,
              totalRecordsCount: 0,
              pageCount: 10
            },
            rowDataOfMrTask: '',
          }
        },
        methods:{
          enableStatusFormatter(column,data){
             return data[column.field] == '0' ? `<span class='task-disable'>${this.$t(`MR.disable`)}</span>`: `<span class='task-enable'>${this.$t(`MR.enable`)}</span>`;
          },

          getTaskListOfMr(){
            const This = this;
            This.page.currentPage = This.$refs.pagerForPmNoRealTaskList.ej2Instances.currentPage;
            this.$axios.get(`/lte/ems/mr/query?pageNo=${This.page.currentPage}&pageSize=${This.page.pageSize}`).then((response) => {
              const result = response.data.resultVal;
              This.page.totalRecordsCount = result.totalCount;
              This.page.currentPage = result.pageNo;
              This.mrTaskData = result.result;
            });
          },
          rowSelectedOfMr(msg) {
            this.rowDataOfMrTask = msg.data;
            this.$emit('enableStatusChange', msg.data.enableStatus);
          },
          rowDeselectedOfMr(msg) {
            this.rowDataOfMrTask = '';
            this.$emit('enableStatusChange', '2');
          },
        },
        mounted() {
          this.$loading.showLoadding(this.$t('System.loading'));
          this.getTaskListOfMr();
          this.$loading.hideLoadding();
        },
    }
</script>

<style>
  .task-enable,
  .task-disable {
    font-size: 12px;
    display: inline-block;
    width: 50px;
    height: 22px;
    color: #fff;
    line-height: 22px;
  }

  .task-disable{
    background-color: #FF0000;
  }

  .task-enable {
    background-color: #13C2C2;
  }
</style>
